import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { DirectieSerii, MassAssign } from '../directie-serii.interface';
import { DirectieSeriiService } from '../directie-serii.service';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-mass-assign-status',
    templateUrl: './mass-assign-status.component.html',
    styleUrls: ['./mass-assign-status.component.scss']
})
export class MassAssignStatusComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    massAssignType = 'active';

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    statusOptions: { name: string; id: number }[] = [
        { name: '--Alegeți--', id: -1, },
        { name: 'Status activ', id: 1 },
        { name: 'Status inactiv', id: 0, }
    ];

    form: FormGroup = new FormGroup({
        status: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { obj_list: string[], type: 'active' | 'public' },
        private dialogRef: MatDialogRef<MassAssignStatusComponent>,
        private requestService: DirectieSeriiService,
        private notificationService: NotificationService,
    ) {
        this.massAssignType = this.data.type;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { status } = this.form.value;
        const payload: MassAssign = {
            obj_list: this.data.obj_list,
            status
        };

        let observableType = new Observable();

        if (this.massAssignType === 'active') {
            observableType = this.requestService
                .updateStatusActiveMass(payload)
        } else {
            observableType = this.requestService
                .updateStatusPublicMass(payload)
        }

        observableType
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
